import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { TextContext } from '@/utils/contexts/TextContext';
import { ModalContext } from '@/utils/contexts/ModalContext';
import BackButton from '@/views/components/BackButton/BackButton';
import TooltipIcon from '@/views/components/TooltipIcon/TooltipIcon';
import api from '@/services/api';

const LetterHeader = ({ currentMode }) => {
	const navigate = useNavigate();

	const { user } = useSelector(state => state.auth);

	const { dict, lastLettersURL } = useSelector((state) => state.app);
	const { contextState, contextDispatch } = useContext(TextContext);

	const { letterData } = contextState;
	const { showModal } = useContext(ModalContext);

	const TemplateButton = (id, templateId, rights, role) => {
		if (templateId) {
			return (
				<div
					className='letter__header--menu-btn'
					style={ { marginLeft: "8px" } }
					onClick={
						() => {
							navigate(`/template/${templateId}`);
						}
					}
				>
					{dict.letter.menu.useTemplate}
				</div>
			);
		} else if (role === 'reader') {
			return <div style={ { marginLeft: "8px" } }>
				Brak
			</div>;
		}

		if (rights.canCreateLetterTemplate) {
			return (
				<>
					<div style={ { marginLeft: "4px", display: 'flex' } }>
						<TooltipIcon 
							color="#0066d3" 
							tooltipText="Utworzenie szablonu jest możliwe po zakończeniu upraszczania." 
						/>
					</div>
					<div
						className='letter__header--menu-btn'
						style={ { marginLeft: "8px" } }
						onClick={
							() => {
								navigate(`/create-template/${id}`);
							}
						}
					>
						+ {dict.letter.menu.createTemplate}
					</div>
				</>
			);
		}

		return (
			<div
				className='letter__header--menu-btn disabled'
				style={ { marginLeft: "8px" } }
			>
				{templateId ? dict.letter.menu.useTemplate : `+ ${dict.letter.menu.createTemplate}`}
			</div>
		);
	};

	return (
		<section className='letter__header'>
			{ contextState.letterData && (
				<div className='letter__header--inner'>
					<div className='letter__header--back-title'>
						<div className='letter__header--back-container'>
							<BackButton
								url={ (lastLettersURL && lastLettersURL.length) > 0 ? lastLettersURL : '/letters' }
								title={ dict.returnLetter }
							/>
							<button
								className='letter__header--preview'
								onClick={
									() => {
										showModal({
											componentName: 'ModalText',
										});
									}
								}
							>
								<i className='icon-question icon' />
								{dict.letter.menu.lookUp}
							</button>
						</div>
						<div className='letter__header--prefix-wrapper'>
							<p className='letter__header--prefix'>{dict.letter.menu.youAreLookingAt}: </p>
						</div>
						<div className='letter__header--title-wrapper'>
							<p className='letter__header--title'>{contextState.letterData.title}</p>
						</div>
						<div className='letter__header--mobile-buttons mobile'>
							<div
								className='letter__header--menu-btn mobile'
								onClick={ () =>{
									contextDispatch({type: 'setViewMetadata', payload: {
										viewMetadata: true,
									}});
								} }>
								{dict.letter.menu.showMetadata}
							</div>
							<div
								className='letter__header--menu-btn mobile'
								onClick={ () => contextDispatch({
									type: 'handleDownloadFile', payload: {
										currentMode,
									},
								}) }>
								{currentMode === 'originalDoc' ? dict.downloadOriginal : dict.downloadWorkingText}
							</div>
						</div>
					</div>
					<menu className='letter__header--menu'>
						<div
							className='letter__header--menu-btn add-divider'
							onClick={ () =>{
								contextDispatch({type: 'setViewMetadata', payload: {
									viewMetadata: true,
								}});
							} }>
							{dict.letter.menu.showMetadata}
						</div>
						<div className='letter__header--menu-info'>
							<span style={ { fontWeight: "500" } }>{ dict.letter.menu.simplifictionPhase } </span> 
							<span style={ { marginLeft: "4px" } }>{ dict.versions[letterData?.version.replaceAll('-', '')]  }</span>
							{ letterData?.version !== 'final' && letterData?.rights?.canEdit && (
								<div
									className='letter__header--menu-btn'
									style={ { marginLeft: "8px" } }
									// className={ `letter__header--menu-btn ${!letterData?.rights?.canEdit ? ' disabled' : ''}` }
									onClick={
										() => {
											if (letterData?.rights?.canEdit) {
												showModal({
													componentName: 'ModalImportFinalVersion',
													additionalInfo: {
														id: contextState.letterData.id,
														templateId: contextState.letterData.letterTemplateId,
													},
												});
											}
										}
									}
								>
									{ dict.letter.menu.finish }
								</div>
							) }
							{ letterData?.version === 'final' && letterData?.rights?.canEdit && (
								<div
									className='letter__header--menu-btn'
									style={ { marginLeft: "8px" } }
									// className={ `letter__header--menu-btn ${!letterData?.rights?.canEdit ? ' disabled' : ''}` }
									onClick={
										() => {
											if (contextState.letterData.letterTemplateId) {
												if (letterData?.rights?.canEdit) {
													showModal({
														componentName: 'ModalContinueSimplification',
														additionalInfo: {
															id: contextState.letterData.id,
														},
													});
												}
											} else {
												api.put(`/letters/${contextState.letterData.id}/simplified`).then(() => {
													navigate(0);
												});
											}
										}
									}
								>
									{ dict.letter.menu.continue }
								</div>
							) }
						</div>
						<div className='letter__header--menu-info'>
							<span style={ { fontWeight: "500" } }>{dict.letter.menu.template}: </span> 
							{TemplateButton(letterData.id, letterData.letterTemplateId, letterData.rights, user.role)}
						</div>
						{ (letterData?.rights?.canDelete && !letterData?.letterTemplateId) && (
							<div
								// className={ `letter__header--menu-btn ${(!letterData?.rights?.canDelete || letterData?.letterTemplateId) ? ' disabled' : ''}` }
								className='letter__header--menu-btn add-divider'
								onClick={ () => {
									if (letterData?.rights?.canDelete) {
										showModal({
											componentName: 'ModalDeleteLetter',
											additionalInfo: {
												id: contextState.letterData.id,
											},
										});
									}
								} }
							>
								{ dict.letter.menu.deleteLetter }
							</div>
						)}
					</menu>
				</div>
			)}

		</section>
	);
};

export default LetterHeader;
